var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55353 0.607422H19.7255C24.1582 0.607422 26.6606 3.12158 26.6736 7.55426V19.7275C26.6736 24.1589 24.1582 26.6744 19.7255 26.6744H7.55353C3.12085 26.6744 0.606689 24.1589 0.606689 19.7275V7.55426C0.606689 3.12158 3.12085 0.607422 7.55353 0.607422ZM13.7041 21.2786C14.2659 21.2786 14.7338 20.8616 14.7859 20.3011V7.02003C14.838 6.61599 14.6438 6.21065 14.2919 5.99038C13.9257 5.76881 13.4825 5.76881 13.1319 5.99038C12.7787 6.21065 12.5845 6.61599 12.6223 7.02003V20.3011C12.6888 20.8616 13.1567 21.2786 13.7041 21.2786ZM19.7006 21.2772C20.248 21.2772 20.7159 20.8601 20.7824 20.2996V16.0247C20.8202 15.6063 20.626 15.2166 20.2728 14.995C19.9222 14.7734 19.479 14.7734 19.1141 14.995C18.7609 15.2166 18.5667 15.6063 18.6188 16.0247V20.2996C18.671 20.8601 19.1389 21.2772 19.7006 21.2772ZM8.71236 20.2994C8.66023 20.8598 8.19233 21.2769 7.63059 21.2769C7.07015 21.2769 6.60094 20.8598 6.55011 20.2994V11.2932C6.51101 10.8879 6.70521 10.4852 7.05842 10.2636C7.40902 10.042 7.85346 10.042 8.20536 10.2636C8.55596 10.4852 8.75277 10.8879 8.71236 11.2932V20.2994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.e5456c1ac2ee841ac0ba066fa7f7203b.svg";
export { ForwardRef as ReactComponent };